import React from "react";
import spinner from "Spinner-1s-200px.svg";
const Loading = () => {
  return <img src={spinner} alt="loading" />;
};

export default Loading;
